import { LayoutComponents } from "@jelly/lesson";
import variables from "../../../../../../../assets/styles/sass-resources.scss";

import config from "appConfig";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 4,
        rows: 4,
        rowsSize: [4, 1, 1, 1],
        colsSize: [1.2, 1, 1, 1],
        colSpan: {
          "0:0": 2,
          "0:2": 2,
          "1:2": 2,
        },
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/19/principle/floating-cover.svg`,
                  },
                },
                styles: {
                  padding: "2%",
                },
              },
            },
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data:
                      "Load bearing construction is massive, but the details and the exact cross-section are unknown. The parquet finish is laid directly on levelled concrete without glue, so it sits loosely on the concrete surface.</br></br>A floating floor is built on top of the existing floor. It is made of a 30 mm thick resilient layer and a 50 mm thick concrete plate placed on top of it as screed. A thin doormat is added as cover on top of the floating floor.",
                    formatter: "html",
                    scrollbars: false,
                    styles: {
                      color: variables["text-secondary"],
                      fontSize: "14px",
                      lineHeight: "18px",
                      fontWeight: 400,
                    },
                  },
                },
              },
            },
          ],
          [
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: "<strong>Light impact</strong>",
                    scrollbars: false,
                    formatter: "html",
                    styles: {
                      letterSpacing: "0.06em",
                      textTransform: "uppercase",
                      fontSize: "10px",
                      lineHeight: "22px",
                      fontWeight: 800,
                    },
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: "<strong>Heavy impact</strong>",
                    scrollbars: false,
                    formatter: "html",
                    styles: {
                      letterSpacing: "0.06em",
                      textTransform: "uppercase",
                      fontSize: "10px",
                      lineHeight: "22px",
                      fontWeight: 800,
                    },
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: "Sound in the source room",
                    scrollbars: false,
                  },
                },
                styles: {
                  justifyContent: "flex-start",
                  fontSize: "14px",
                  fontWeight: 700,
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "primary",
                    text: "tapping</br>machine",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/19/principle/floating-floor-with-cover-tapping-machine-source-room.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "primary",
                    text: "child jumping</br>(25kg)",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/19/principle/floating-floor-with-cover-child-jumping-source-room.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "primary",
                    text: "man thumping</br>(120 kg)",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/19/principle/floating-floor-with-cover-man-thumping-source-room.wav`,
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: "Sound in the receiving room",
                    scrollbars: false,
                  },
                },
                styles: {
                  justifyContent: "flex-start",
                  fontSize: "14px",
                  fontWeight: 700,
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "secondary",
                    text: "tapping</br>machine",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/19/principle/floating-floor-with-cover-tapping-machine-receiving-room.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "secondary",
                    text: "child jumping</br>(25kg)",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/19/principle/floating-floor-with-cover-child-jumping-receiving-room.wav`,
                  },
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    icon: "cis-volume-high",
                    theme: "secondary",
                    text: "man thumping</br>(120 kg)",
                    shape: "round",
                    size: "small",
                    url: `${config.ASSETS_URL}/05/19/principle/floating-floor-with-cover-man-thumping-receiving-room.wav`,
                  },
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
